import * as usersUrls from 'mk2/apps/users/urls';
import { Route } from 'mk2/containers/Application/Application';

export const routes: Route[] = [{
    app: 'users',
    exact: true,
    path: usersUrls.usersManualPhoneVerification,
    getPage: () => {
        return import('mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerificationPage' /* webpackChunkName: "users.ManualPhoneVerification" */);
    },
    modules: [ 'mk2/apps/users/containers/ManualPhoneVerification/ManualPhoneVerificationPage' ],
}, {
    app: 'users',
    exact: true,
    path: usersUrls.signupIFrameSimple,
    getPage: () => {
        return import('mk2/apps/users/containers/SignupIFrame/SignupIFramePage' /* webpackChunkName: "users.SignupIFrame" */);
    },
    modules: [ 'mk2/apps/users/containers/SignupIFrame/SignupIFramePage' ],
}, {
    app: 'users',
    exact: true,
    path: usersUrls.signup,
    getPage: () => {
        return import('mk2/apps/users/containers/Signup/SignupPage' /* webpackChunkName: "users.Signup" */);
    },
    modules: [ 'mk2/apps/users/containers/Signup/SignupPage' ],
}, {
    app: 'users',
    exact: true,
    path: usersUrls.login,
    getPage: () => {
        return import('mk2/apps/users/containers/Login/LoginPage' /* webpackChunkName: "users.Login" */);
    },
    modules: [ 'mk2/apps/users/containers/Login/LoginPage' ],
}, {
    app: 'users',
    exact: true,
    path: usersUrls.formsGallery,
    getPage: () => {
        return import('mk2/apps/users/containers/FormsGallery/FormsGalleryPage' /* webpackChunkName: "users.FormsGallery" */);
    },
    modules: [ 'mk2/apps/users/containers/FormsGallery/FormsGalleryPage' ],
}];
